import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import Fine from './fine.jsx';

export default class ThisDriversCurrentFines extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      url: props.url || '/api/v1/portal/drivers/fines',
      fineAccountId: props.fineAccountId || null,
      fines: [],
    };
  }

  componentDidMount() {
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/fines/'+this.state.fineAccountId+'/current',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(finesJson) {
      that.setState({
        fines: finesJson,
        isLoading: false
      });
    });
  }

  render() {
      var Fines = [];

      if (this.state.fines.length > 0) {
        this.state.fines.forEach(function(i) {
            Fines.push(<Fine key={'fine-'+i.id} data={i} />);
          });
        }
    return (
        <div>
            <div className="row fines-table-header">
                <div className="col-md-2">
                    description
                </div>
                <div className="col-md-1" title="reference">
                    ref
                </div>
                <div className="col-md-2">
                    amounts
                </div>
                <div className="col-md-2">
                    frequency
                </div>
                <div className="col-md-1">
                    details
                </div>
                <div className="col-md-2">
                    StartDate
                </div>
                <div className="col-md-2">
                    EndDate
                </div>
            </div>
            {Fines}
        </div>
    );
  }
}
